import React, { useEffect, useState } from 'react';
import { Button, List, Typography, Row, Col, Badge, Tooltip, Switch, Tag } from 'antd';
import { CheckOutlined, MessageOutlined, RocketOutlined, CrownOutlined } from '@ant-design/icons';
import { AnimatedCard, DescriptionFeatures, fetchPlans } from './PricingUtils';
import { pricingStyles } from './pricingStyles';
import { useMyContext } from 'Context/MyContextProvider';
import { landingButtonGradient } from '../LandingPages/components/LandingUtils';
import PlanDetailsPage from '../LandingPages/components/PlanDetailsPage';
import { useNavigate } from 'react-router-dom';
const { Title, Text } = Typography;




export default function SMSForYouPricing() {
    const { api, authToken } = useMyContext();
    const navigate = useNavigate();
    const [hoveredPlan, setHoveredPlan] = useState(null);
    const [pricingPlans, setPricingPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [isYearly, setIsYearly] = useState(false);

    useEffect(() => {
        fetchPlans(api, setPricingPlans);
    }, [api]);

    // Pricing for yearly toggle (example: 2 months free)
    const getPeriod = () => (isYearly ? '/year' : '/month');
  
    const HandleSelectedPlan = (plan) => {
        setSelectedPlan(plan);
        // Navigate to plan details page with plan data
        navigate(`/pricing/plan-detail/${plan.id}`, {
            state: {
                selectedPlan: plan,
                isYearly: isYearly,
                planPrice: isYearly ? plan.yearly_price : plan.monthly_price,
                planPeriod: isYearly ? 'yearly' : 'monthly'
            }
        });
    };

    return (
        <div className="sms-for-you-pricing" id='pricing'>
            <div style={pricingStyles.container}>
                <div className="title py-5" style={pricingStyles.titleSection}>
                    <div style={{ marginBottom: '1rem' }}>
                        <Badge color="#00c853" count={<span style={{ color: '#009624', fontWeight: 600 }}>SMS FOR YOU</span>} style={pricingStyles.badge} />
                    </div>
                    <Title level={1} style={pricingStyles.mainTitle}>
                        Choose Your Perfect Plan
                    </Title>
                    <Text style={pricingStyles.subtitle}>
                        Scale your business outreach with our flexible WhatsApp API plans. Start small and grow as your customer engagement expands.
                    </Text>
                </div>
                <div style={pricingStyles.switchRow}>
                    <Text style={pricingStyles.switchText(!isYearly)}>Monthly</Text>
                    <Switch
                        checked={isYearly}
                        onChange={setIsYearly}
                        checkedChildren={null}
                        unCheckedChildren={null}
                        style={pricingStyles.switch(isYearly)}
                    />
                    <Text style={pricingStyles.switchText(isYearly)}>Yearly</Text>
                </div>
            </div>
            <div className="container">
                <Row gutter={[32, 32]} justify="center">
                    {pricingPlans?.map((plan, index) => (
                        <Col xs={24} md={8} key={index}>
                            {plan?.recommended === 1 && (
                                <div style={{ position: 'absolute', top: '0rem', right: '1rem', transform: 'translateX(-50%)', zIndex: 2 }}>
                                    <Badge.Ribbon text="Most Popular" color={landingButtonGradient} style={{ fontSize: '17px' }} />
                                </div>
                            )}
                            <AnimatedCard
                                bodyStyle={pricingStyles.cardBody}
                                style={pricingStyles.card(plan)}
                                onMouseEnter={() => setHoveredPlan(index)}
                                onMouseLeave={() => setHoveredPlan(null)}
                                hoverable
                                cover={
                                    <div style={pricingStyles.cardCover}>
                                        {/* <FloatingIcon>
                                            <IconContainer>{plan.icon}</IconContainer>
                                        </FloatingIcon> */}
                                        <Title level={3} style={pricingStyles.planTitle}>
                                            {plan.title}
                                        </Title>
                                        <div style={{ textAlign: 'center' }}>
                                            <Title level={1} style={pricingStyles.planPrice}>
                                                ₹{isYearly ? plan?.yearly_price : plan?.monthly_price}
                                                <span style={pricingStyles.planPeriod}>
                                                    {getPeriod()}
                                                </span>
                                            </Title>
                                        </div>
                                    </div>
                                }
                            >
                                <Button
                                    type={plan.recommended ? 'primary' : 'default'}
                                    size="large"
                                    block
                                    className={plan.recommended ? 'premium-btn' : ''}
                                    style={pricingStyles.planButton(plan, hoveredPlan, index)}
                                    onClick={() => HandleSelectedPlan(plan)}
                                >
                                    {plan.button_text}
                                </Button>

                                <List
                                    itemLayout="horizontal"
                                    dataSource={plan.feature_data}
                                    style={pricingStyles.featureList}
                                    renderItem={(item) => (
                                        <List.Item style={pricingStyles.featureItem}>
                                            <Text>
                                                <Tag color="#e8f7ed" className='border-0 rounded-circle'>
                                                    <CheckOutlined style={pricingStyles.featureTag} />
                                                </Tag>
                                                {item?.name}
                                            </Text>
                                        </List.Item>
                                    )}
                                />

                            </AnimatedCard>
                        </Col>
                    ))}
                </Row>
            </div>
            <div style={pricingStyles.whySection}>
                <div style={pricingStyles.whyContainer}>
                    <Title level={2} style={pricingStyles.whyTitle}>
                        Why Choose SMS For You?
                    </Title>
                    <Text style={pricingStyles.whySubtitle}>
                        All plans include these essential features to power your SMS campaigns
                    </Text>
                    <Row gutter={[32, 32]} justify="center" style={{ marginTop: 32 }}>
                        {DescriptionFeatures.map((feature, index) => (
                            <Col xs={24} md={6} key={index}>
                                <div style={{ textAlign: 'center' }}>
                                    <div style={pricingStyles.whyFeatureIcon}>
                                        {feature.icon}
                                    </div>
                                    <Title level={4} style={pricingStyles.whyFeatureTitle}>
                                        {feature.title}
                                    </Title>
                                    <Text style={pricingStyles.whyFeatureDesc}>{feature.description}</Text>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>

            {/* Ready to Get Started Section */}
            <div style={pricingStyles.ctaSection}>
                <Title level={2} style={pricingStyles.ctaTitle}>
                    Ready to Get Started?
                </Title>
                <Text style={pricingStyles.ctaSubtitle}>
                    Join thousands of businesses already using SMS For You to reach their customers
                </Text>
                <Button type="primary" size="large" style={pricingStyles.ctaButton}>
                    Start Free Trial
                </Button>
            </div>
        </div>
    );
}
